import { ConfigStore } from "../../stores";
export function storeToken(token) {
    ConfigStore.config.connections.jwt = token;
}
//# sourceMappingURL=storeToken.js.map